<app-form-section headerKey="label.type" [sectionOptions]="['noDiv']" *ngIf="residentType == ResidentType.LANDLORD">
  <app-radio-input
    *ngIf="landlordTypesControl"
    [disabled]="true"
    [options]="landlordTypes"
    [formControl]="landlordTypesControl"
  ></app-radio-input>
</app-form-section>
<app-form-section *ngIf="isCompany" headerKey="label.nip" [sectionOptions]="['noDiv', 'pad']">
  <div class="grayed">{{ residentData!.NIP }}</div>
</app-form-section>
<app-form-section [headerKey]="isCompany ? 'sub.firmData' : 'user.nameSurname'" [sectionOptions]="['noDiv', 'pad']">
  <div class="grayed">{{ residentData | fullName }}</div>
</app-form-section>
<app-form-section
  [headerKey]="isCompany ? 'label.companyAddr' : 'user.postAddr'"
  *ngIf="residentData.address"
  [sectionOptions]="['noDiv', 'pad']"
>
  <div class="grayed">{{ residentData.address | address }}</div>
</app-form-section>
<app-form-section *ngIf="isCompany" headerKey="label.regon" [sectionOptions]="['noDiv', 'pad']">
  <div class="grayed">{{ residentData!.REGON || '-' }}</div>
</app-form-section>
<app-form-section [sectionOptions]="['noDiv', 'pad']" *ngIf="!isCompany && hasAdditionalData" headerKey="user.additData">
  <div class="grayed" *ngIf="residentData.birthDate">
    <b>{{ 'user.birthDate' | locCap }}: </b> {{ residentData.birthDate | lDate: 'dShort' }}
  </div>
  <div class="grayed" *ngIf="residentData.PESEL">
    <b>{{ 'user.pesel' | loc }}: </b> {{ residentData.PESEL }}
  </div>
  <div class="grayed" *ngIf="residentData.documentNo">
    <b>{{ 'user.documentNo' | locCap }}: </b> {{ residentData.documentNo }}
  </div>
  <div class="grayed" *ngIf="residentData.nationality">
    <b>{{ 'user.national' | locCap }}: </b> {{ residentData.nationality }}
  </div>
</app-form-section>
<app-form-section headerKey="user.ownerCode">
  <div class="grayed">{{ residentData.ownerCode ?? '-' }}</div>
</app-form-section>

<app-form-section headerKey="label.email" [sectionOptions]="['noDiv', 'pad']">
  <div class="grayed">{{ arrayJoined(residentData.email) }}</div>
</app-form-section>
<app-form-section headerKey="label.phone">
  <div class="grayed">{{ arrayJoined(residentData.phone) }}</div>
</app-form-section>

<app-form-section headerKey="user.emergeContact" *ngIf="residentData.emergencyContact as contact">
  <div class="grayed">{{ contact | nameContact }}</div>
</app-form-section>
